import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-public-releases',
  templateUrl: './public-releases.component.html',
  styleUrls: ['./public-releases.component.scss']
})
export class PublicReleasesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
